import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { useOnboarding } from '@/pages/Onboarding/context';
import { liftUpSceneChoices } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/choicePanelOptions';
import { GenericScreenLayout } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/GenericScreenLayout';

export const LiftUpScreen: React.FC = () => {
  const { wizard } = useOnboarding();

  const handleNextStep = (value?: string) => {
    switch (value) {
      case 'Wrap your legs':
        wizard.goToStep('final_consent_screen_a');
        break;
      case 'Grab his hair':
        wizard.goToStep('final_consent_screen_b');
        break;
      default:
        wizard.goToStep('');
        break;
    }
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/lift-up-scene.png`}
      title={[{ text: 'He lifts you.', italic: true }]}
      choices={liftUpSceneChoices.map((option) => ({
        ...option,
        onClick: () => handleNextStep(option.label),
      }))}
    />
  );
};
